import React from "react"

import { Form, Formik } from "formik"
import { buildMutation, compress, useMutation } from "micro-graphql-react"

import {
  Field,
  FormStatus,
  SubmitButton,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const EditName = ({ availabilitySetId, name }) => {
  const formState = {
    availabilitySetId,
    name,
  }

  const { runMutation } = useMutation(buildMutation(updateMutation))

  const handleSubmit = (values, actions, closeModal) => {
    runMutation(values)
      .then(
        response => {
          const { errorMessages } = response.availabilitySetUpdate
          if (errorMessages) {
            actions.setStatus(errorMessages)
            actions.setSubmitting(false)
          } else {
            closeModal()
          }
        },
        () => {
          actions.setStatus("Something went wrong")
          actions.setSubmitting(false)
        }
      )
      .catch(() => {
        actions.setStatus("Something went wrong")
        actions.setSubmitting(false)
      })
  }

  return (
    <ModalWithProvidedBody
      modalTitle="Edit Name"
      buttonText="Edit Name"
      buttonClassName="btn btn-info"
    >
      {({ closeModal }) => (
        <Formik
          initialValues={formState}
          onSubmit={(values, actions) =>
            handleSubmit(values, actions, closeModal)
          }
        >
          <Form>
            <div className="modal-body">
              <Field name="name" label="Name" />
            </div>

            <div className="modal-footer flex-column">
              <FormStatus />
              <div className="d-flex justify-content-between w-full">
                <button
                  onClick={closeModal}
                  type="button"
                  className="btn btn-danger"
                >
                  Cancel
                </button>
                <SubmitButton />
              </div>
            </div>
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const updateMutation = compress`
  mutation($availabilitySetId: ID!, $name: String) {
    availabilitySetUpdate(availabilitySetId: $availabilitySetId, name: $name) {
      errorMessages
      availabilitySet {
        id
        name
      }
    }
  }
`

export default EditName
